import { Layout } from "antd"
import MapsFullScreen from "../../../component/maps/MapsFullScreen"
import { MapsIcon } from "../../../asset"
import { useLocation } from "react-router-dom"

const MapsDepot = ()=>{
  let location = useLocation()

  console.log("locationn", location);
  return(
    <>
    <Layout.Header
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          zIndex: 1,
          boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.15)",
          height:"90px"
        }}
      >
        <div className="mt-6 flex">
          <img className="h-10" src={MapsIcon} alt="map"/>
          <div>
            <div className="text-red-100 mt-[-6px] font-bold ml-2 text-xl">Bojong Nangka</div>
            <div className="text-red-100 mt-[-20px] font-semibold ml-2">Kelapa Dua, Gading Serpong Regency</div>
          </div>
        </div>
      </Layout.Header>
      <div >
          <MapsFullScreen
          lat={location?.state?.depot_latitude}
          long={location?.state?.depot_longitude}/>
      </div>
    </>
  )
}
export default MapsDepot